import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";
import VendorLabors from "../views/Vendor/VendorLabors.vue";
import MessagesList from "../views/Messages/MessagesList.vue";
import PrivacyPolicy from "../views/Pages/PrivacyPolicy.vue";
import PendingPayments from "../views/PendingPayments/PendingPayments.vue";
import VoucherList from "../views/VoucherList/VoucherList.vue";

//POS
const Pos = () => import("@/views/Pos/Pos.vue");
const SaleList = () => import("@/views/Pos/SaleList.vue");
const SaleQuotation = () => import("@/views/Pos/SaleQuotations.vue");
const CreditNoteList = () => import("@/views/Pos/CreditNoteList.vue");

// product pages
const AddProduct = () => import("@/views/Product/AddProduct.vue");
const ProductList = () => import("@/views/Product/ProductList.vue");
const ShowBarcode = () => import("@/views/Product/ShowBarcode.vue");

// role pages
const RoleList = () => import("@/views/Role/RoleList.vue");

// attributes
const AttributeList = () => import("@/views/Attribute/AttributeList.vue");

// user pages
const AddUser = () => import("@/views/User/AddUser.vue");
const UserList = () => import("@/views/User/UserList.vue");
const CustomerList = () => import("@/views/User/CustomerList.vue");
const CustomerChalans = () => import("@/views/Pos/CustomerChalans.vue");

// supplier pages
const SupplierList = () => import("@/views/Supplier/SupplierList.vue");

// service Category page
const ServiceCategoryList = () =>
  import("@/views/ServiceCategory/ServiceCategoryList.vue");

// service Request page
const ServiceRequestList = () =>
  import("@/views/ServiceRequest/ServiceRequestList.vue");

// add service request page
const AddServiceRequest = () =>
  import("@/views/ServiceRequest/AddServiceRequest.vue");

// service request timelines
const ServiceRequestTimeline = () =>
  import("@/views/ServiceRequest/ServiceRequestTimeline.vue");

// service request flow
const ServiceRequestFlow = () =>
  import("@/views/ServiceRequest/ServiceRequestFlow/ServiceRequestFlow.vue");

// job page
const ServiceJobList = () => import("@/views/ServiceJob/ServiceJobList.vue");
// status page
const StatusList = () => import("@/views/Status/StatusList.vue");
// service page
const ServiceList = () => import("@/views/Service/ServiceList.vue");
// vendor page
const VendorList = () => import("@/views/Vendor/VendorList.vue");
const AddVendor = () => import("@/views/Vendor/AddVendor.vue");
// vendor type page
const VendorTypeList = () => import("@/views/VendorType/VendorTypeList.vue");

//payments
const TransactionsList = () => import("@/views/Payment/TransactionsList.vue");

// product unit pages
const ProductUnitList = () => import("@/views/ProductUnit/ProductUnitList.vue");

// product unit pages
const PaymentModeList = () => import("@/views/PaymentMode/PaymentModeList.vue");

// tax page
const TaxList = () => import("@/views/Tax/TaxList.vue");

// expense pages
const ExpenseList = () => import("@/views/Expense/ExpenseList.vue");
const ExpenseTypeList = () => import("@/views/Expense/ExpenseTypeList.vue");

//labor cost
const LaborCostList = () => import("@/views/LaborCost/LaborCostList.vue");
// chalans list
const ChalanList = () =>
  import("@/views/ServiceRequestChalan/ServiceRequestChalanList.vue");

// quotations list
const QuotationList = () =>
  import("@/views/ServiceRequestQuotation/ServiceRequestQuotationList.vue");
// bill requests list
const BillRequestsList = () =>
  import("@/views/BillRequest/BillRequestsList.vue");
// Jobs list
const JobsList = () => import("@/views/Job/JobList.vue");

// Calendar
const Calendar = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );
const Widgets = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Widgets.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");
const Home = () => import("@/views/Pages/Home.vue");
const Terms = () => import("@/views/Pages/Terms.vue");
const Icons = () => import("@/views/Components/Icons.vue");

const ForgotPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ForgotPassword.vue");

const CreateServiceRequestCard = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/CreateServiceRequestCard.vue"
  );

// purchases
const PurchaseList = () => import("@/views/Purchase/PurchaseList.vue");
const AddPurchase = () => import("@/views/Purchase/AddPurchase.vue");

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      component: User
    },
    {
      path: "timeline",
      name: "Timeline Page",
      component: TimeLine
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  redirect: "/home",
  children: [
    {
      path: "/register-request",
      name: "Register Request",
      component: CreateServiceRequestCard
    },
    {
      path: "/securegate",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/forgotPassword",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: PrivacyPolicy
    },
    // {
    //   path: "/icons",
    //   name: "Icons",
    //   component: Icons
    // },

    { path: "*", component: NotFound }
  ]
};

let expenseMenu = {
  path: "/expenses",
  component: DashboardLayout,
  name: "Expense List",
  children: [
    {
      path: "list",
      name: "Expenses",
      component: ExpenseList,
      meta: {
        navbarType: "light"
      }
    },
    {
      path: "type/list",
      name: "Expense Types",
      component: ExpenseTypeList,
      meta: {
        navbarType: "light"
      }
    }
  ]
};
const routes = [
  {
    path: "/",
    component: Home,
    name: "Login"
  },
  pagesMenu,
  expenseMenu,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",
    meta: { middlewareAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "alternative",
        name: "Alternative",
        component: AlternativeDashboard,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar
      },
      {
        path: "pos",
        name: "Pos",
        component: Pos,
        meta: {
          navbarType: "dark",
          hideFooter: true,
          hideNavbar: true
        }
      },
      {
        path: "products/add",
        name: "Add Product",
        component: AddProduct,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "products/add/:productId",
        name: "Edit Product",
        component: AddProduct,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "products/list",
        name: "Products",
        component: ProductList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "products/barcode",
        name: "Product Barcode",
        component: ShowBarcode,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "product-units/list",
        name: "Product Units",
        component: ProductUnitList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "roles/list",
        name: "Roles",
        component: RoleList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "attributes/list",
        name: "Attributes",
        component: AttributeList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "users/add",
        name: "Add User",
        component: AddUser,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "users/add/:userId",
        name: "Edit User",
        component: AddUser,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "users/list",
        name: "Users",
        component: UserList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "customers",
        name: "Users",
        component: CustomerList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "pos/:id",
        name: "Edit Sale",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit",
          hideFooter: true,
          type: "edit"
        }
      },
      {
        path: "pos/:id/credit-notes",
        name: "Credit Notes",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "credit-note",
          hideFooter: true,
          type: "edit"
        }
      },
      {
        path: "sales/list",
        name: "Sales",
        component: SaleList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/sales/quotations",
        name: "User Quotations",
        component: SaleQuotation,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/sales/quotations/:userQuotationId",
        name: "User Quotations",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit-user-quotation",
          hideFooter: true,
          type: "edit"
        }
      },
      {
        path: "creditNote/list",
        name: "Credit Notes",
        component: CreditNoteList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/customer-chalans",
        name: "Customer chalans",
        component: CustomerChalans,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/customer-chalans/:customerChalanId",
        name: "Customer chalan",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit-customer-chalan",
          type: "edit"
        }
      },
      {
        path: "/merge-customer-chalans",
        name: "merge-customer-chalans",
        component: Pos,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "suppliers/list",
        name: "Suppliers",
        component: SupplierList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "serviceCategories/list",
        name: "Service Categories",
        component: ServiceCategoryList,
        meta: {
          navbarType: "light"
        }
      },

      {
        path: "vendorTypes/list",
        name: "Vendor Types",
        component: VendorTypeList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "services/list",
        name: "Services",
        component: ServiceList,
        meta: {
          navbarType: "light"
        }
      },

      {
        path: "statuses/list",
        name: "Statuses",
        component: StatusList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "service/jobs/list",
        name: "Service Jobs",
        component: ServiceJobList,
        meta: {
          navbarType: "light"
        }
      },

      {
        path: "serviceRequests/list",
        name: "Service Requests",
        component: ServiceRequestList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "messages/list",
        name: "Service Requests",
        component: MessagesList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/accept/payments",
        name: "Accept Payments",
        component: PendingPayments,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "/vouchers/list",
        name: "Vouchers",
        component: VoucherList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "serviceRequests/timeline/:id",
        name: "Timeline",
        component: ServiceRequestTimeline,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "serviceRequests/flow/:id",
        name: "Service Request Flow",
        component: ServiceRequestFlow,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "serviceRequests/add",
        name: "Service Requests",
        component: AddServiceRequest,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "serviceRequests/edit/:id",
        name: "Service Requests",
        component: AddServiceRequest,
        meta: {
          navbarType: "light",
          mode: "edit"
        }
      },
      {
        path: "vendors/list",
        name: "Vendors",
        component: VendorList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "vendors/add",
        name: "Add Vendor",
        component: AddVendor,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "vendors/:vendorId/labors",
        name: "Vendor's Labors",
        component: VendorLabors,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "vendors/:vendorId/edit",
        name: "Edit Vendor",
        component: AddVendor,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "transactions/list",
        name: "Payments",
        component: TransactionsList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "payment-modes/list",
        name: "Payment Modes",
        component: PaymentModeList,
        meta: {
          navbarType: "light"
        }
      },

      {
        path: "taxes/list",
        name: "Taxes",
        component: TaxList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "chalans/list",
        name: "Chalans List",
        component: ChalanList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "chalan/:chalanId",
        name: "Edit Chalan",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit-chalan",
          hideFooter: true,
          type: "edit"
        }
      },
      {
        path: "quotation/:quotationId",
        name: "Edit Quotation",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit-quote",
          hideFooter: true,
          type: "edit"
        }
      },
      {
        path: "quotations/list",
        name: "Quotation List",
        component: QuotationList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "billRequests/list",
        name: "Bill Requests",
        component: BillRequestsList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets
      },
      {
        path: "labor/costs/list",
        name: "Labor Cost",
        component: LaborCostList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "jobs/list",
        name: "Jobs",
        component: JobsList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "purchases/list",
        name: "Purchase",
        component: PurchaseList,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "purchases/add",
        name: "Add Purchase",
        component: AddPurchase,
        meta: {
          navbarType: "light"
        }
      },
      {
        path: "purchases/:purchaseId/edit",
        name: "Edit Purchase",
        component: AddPurchase,
        meta: {
          navbarType: "light",
          mode: "edit"
        }
      },
      {
        path: "billRequests/:billRequestId",
        name: "Edit Bill Request",
        component: Pos,
        meta: {
          navbarType: "light",
          mode: "edit-bill-request"
        }
      }
    ]
  },
  authPages
];
export default routes;
